import { render, staticRenderFns } from "./nav_title.vue?vue&type=template&id=12515130&scoped=true&"
import script from "./nav_title.vue?vue&type=script&lang=js&"
export * from "./nav_title.vue?vue&type=script&lang=js&"
import style0 from "./nav_title.vue?vue&type=style&index=0&id=12515130&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12515130",
  null
  
)

export default component.exports